import { Col, Modal } from 'react-bootstrap';
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { StepperComponent } from '../../../../_metronic/assets/ts/components';
import { deletePartyLedger } from './party-ledgers-list/core/_requests';
import { setMessage } from '../../../../store/alertMessage/actions';
import { useQueryResponse } from './party-ledgers-list/core/QueryResponseProvider';
import { useQueryRequest } from './party-ledgers-list/core/QueryRequestProvider';

const modalsRoot = document.getElementById('root-modals') || document.body;

const DeletepartyLedger = ({ show, handleClose, id }: any) => {
  const [password, setPassword] = useState('');
  const stepperRef = useRef<HTMLDivElement | null>(null);
  const stepper = useRef<StepperComponent | null>(null);
  const [loading, setLoading] = useState<any>(false);
  const dispatch = useDispatch();
  const { refetch } = useQueryResponse();
  const { updateState } = useQueryRequest();
  const passwordInputRef = useRef<HTMLInputElement>(null);
  const [isDeleteConfirm, setDeleteConfirm] = useState(false);

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement);
  };

  const deleteAction = async () => {
    try {
      if (!id) {
        console.error('Error: Transaction ID is missing!');
        dispatch(setMessage('error', 'Transaction ID is missing!'));
        return;
      }

      if (!password.trim()) {
        dispatch(setMessage('error', 'Password is required!'));
        return;
      }

      setLoading(true);

      const payload = { password: password.trim() };
      console.log('Deleting ID:', id, 'with payload:', payload);

      const data = await deletePartyLedger(id, payload);
      console.log('Response Data:', data);

      if (data?.status === 200 || data?.responseStatus === 200) {
        dispatch(setMessage('success', data?.data?.message ?? 'Transaction deleted successfully.'));
        setDeleteConfirm(true);
        setTimeout(() => {
          handleClose();
          refetch();
        }, 1000);
      } else {
        if (data?.status === 400 && data?.Error?.message === "Please enter correct password") {
          dispatch(setMessage('error', "Please enter correct password"));
        } else {
          dispatch(setMessage('error', data?.data?.message ?? data?.responseMessage));
        }
      }
    } catch (error: any) {
      console.error('Error deleting:', error);
      if (error?.response?.status === 400) {
        const errorData = error?.response?.data?.message;

       

        dispatch(setMessage("error", errorData));
      } else {
        
        dispatch(setMessage("error", error?.response?.data?.message || "An unexpected error occurred"));
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      setDeleteConfirm(false);
      setPassword('');
      setTimeout(() => {
        passwordInputRef.current?.focus();
      }, 100);
    }
  }, [show]);

  const onClose = () => {
    handleClose();
    updateState({ page: 1 });
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !loading) {
      e.preventDefault();
      deleteAction();
    }
  };

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-450px delete-model'
      show={show}
      onHide={onClose}
      onEntered={loadStepper}
      backdrop='static'
    >
      <div className='modal-body pt-10'>
        {!isDeleteConfirm && (
          <>
            <div className='icon text-center'>
              <div className='symbol symbol-65px symbol-circle symbol-icon text-center mb-10'>
                <span className='symbol-label bg-danger'>
                  <i className='fa-solid fa-trash fs-4 text-white fs-3'></i>
                </span>
              </div>
            </div>
            <h3 className='text-danger text-center fs-5'>Delete Party Ledger</h3>
            <p className='text-center mb-5 fs-8'>
              if you delete this transaction still you will find under Deleted Transactions Report
            </p>
            <input
              ref={passwordInputRef}
              type='password'
              className='form-control bg-transparent'
              placeholder='Password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyPress}
            />
            <Col className='me-5 mt-10 text-center'>
              <button
                type='button'
                className='btn btn-sm me-5 btn btn-danger'
                onClick={deleteAction}
                disabled={loading}
              >
                Delete
              </button>
              <button
                type='button'
                className='btn btn-sm btn btn-light btn-outline border-dark'
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
            </Col>
          </>
        )}
        {isDeleteConfirm && (
          <div className='deletemessage'>PartyLedger is removed from the system</div>
        )}
      </div>
    </Modal>,
    modalsRoot
  );
};

export default DeletepartyLedger;